import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("td", null, " Name: ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", null, "Company:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", null, "Abteilung:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, "Telefonnummer:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, "Geburtsdatum:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, "Kontonummer:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, "Dienstnummer:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, "Venture Mail:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, "Ausweis ID:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, "Beigetreten am:", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, "Letzte Beförderung:", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, " Führerschein: ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, "Tauchschein:", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, "Sonstiges:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_snackbar = _resolveComponent("error-snackbar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_employee_form = _resolveComponent("employee-form")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_DocumentEditor = _resolveComponent("DocumentEditor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_error_snackbar, {
      snackbar: _ctx.errorSnackbar,
      "onUpdate:snackbar": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.errorSnackbar) = $event))
    }, null, 8, ["snackbar"]),
    _createVNode(_component_v_col, {
      cols: "12",
      sm: "6",
      md: "4",
      lg: "4",
      xl: "3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { dark: true }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "d-flex align-items-start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "10" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expandCard(_ctx.member.id))),
                      style: {"cursor":"pointer"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" [" + _toDisplayString(_ctx.member.servicenumber) + "] " + _toDisplayString(_ctx.member.name), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.member.rank), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_subtitle, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.member.companies, (company, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            _createTextVNode(_toDisplayString(company.name), 1)
                          ], 64))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.member.departments, (department, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            _createTextVNode(" | " + _toDisplayString(department.name), 1)
                          ], 64))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editNotes(_ctx.member))),
                          style: {"cursor":"pointer","color":"brown"}
                        }, "Notizen anzeigen")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "d-flex justify-end align-top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: _ctx.getImage(_ctx.logoURL),
                      width: "64",
                      height: "64",
                      class: "d-inline-block mt-2 mr-2"
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.expandedIndex === _ctx.member.id)
              ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.member.phone), 1),
                    _hoisted_1,
                    _createVNode(_component_v_divider, { class: "border-opacity-100 mb-4" }),
                    _createVNode(_component_v_table, null, {
                      default: _withCtx(() => [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _hoisted_2,
                            _createElementVNode("td", null, _toDisplayString(_ctx.member.name), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_3,
                            _createElementVNode("td", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.member.companies, (company, index) => {
                                return (_openBlock(), _createBlock(_component_v_chip, {
                                  key: index,
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(company.name), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_4,
                            _createElementVNode("td", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.member.departments, (department, index) => {
                                return (_openBlock(), _createBlock(_component_v_chip, {
                                  key: index,
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(department.name), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_5,
                            _createElementVNode("td", null, _toDisplayString(_ctx.member.phonenumber), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_6,
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.member.birthdate)), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_7,
                            _createElementVNode("td", null, _toDisplayString(_ctx.member.bankaccount), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_8,
                            _createElementVNode("td", null, _toDisplayString(_ctx.member.servicenumber), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_9,
                            _createElementVNode("td", null, _toDisplayString(_ctx.member.mail), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_10,
                            _createElementVNode("td", null, _toDisplayString(_ctx.member.personalid), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_11,
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.member.entrydate)), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_12,
                            _createElementVNode("td", null, [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.member.last_promotion)) + " ", 1),
                              _createElementVNode("a", {
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showPromotionsDialog && _ctx.showPromotionsDialog(...args))),
                                style: {"cursor":"pointer","color":"brown"}
                              }, "(Mehr)")
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider, { class: "border-opacity-100 mb-4" }),
                    _createVNode(_component_v_table, null, {
                      default: _withCtx(() => [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _hoisted_13,
                            _createElementVNode("td", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLicenses('driverlicense'), (license) => {
                                return (_openBlock(), _createBlock(_component_v_chip, {
                                  key: license.id,
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(license.license), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_14,
                            _createElementVNode("td", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLicenses('diverlicense'), (license) => {
                                return (_openBlock(), _createBlock(_component_v_chip, {
                                  key: license.id,
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(license.license), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_15,
                            _createElementVNode("td", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLicenses('medic'), (license) => {
                                return (_openBlock(), _createBlock(_component_v_chip, {
                                  key: license.id,
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(license.license), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider, { class: "border-opacity-100 mb-4" })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  text: "true",
                  onClick: _ctx.editUser
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Edit ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_employee_form, {
                  ref: "employeeForm",
                  "edit-mode": _ctx.editMode,
                  "hide-edit-button": true
                }, null, 8, ["edit-mode"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.promotionDialog,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.promotionDialog) = $event)),
      "max-width": "700px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "headline" }, {
              default: _withCtx(() => [
                _createTextVNode("Beförderungsverlauf")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  headers: _ctx.promotionTableHeaders,
                  items: _ctx.promotionsArray,
                  class: "elevation-1",
                  "sort-by": [{ key: 'promotion_date', order: 'desc' }]
                }, null, 8, ["headers", "items"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  text: "true",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.promotionDialog = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Schließen")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_DocumentEditor, {
      class: "document-editor-container",
      selectedDocumentPreview: _ctx.content,
      categories: [],
      onCloseDocument: _ctx.resetSelectedDocument,
      persistent: ""
    }, null, 8, ["selectedDocumentPreview", "onCloseDocument"]),
    _createVNode(_component_DocumentEditor, {
      class: "document-editor-container",
      selectedDocumentEmployeeDocument: _ctx.selectedDocumentEmployeeNotes,
      categories: [],
      "onUpdate:selectedDocumentEmployeeDocument": _ctx.updateSelectedDocumentEmployeeNotes,
      onCloseDocument: _ctx.resetSelectedDocumentEmployeeNotes,
      persistent: ""
    }, null, 8, ["selectedDocumentEmployeeDocument", "onUpdate:selectedDocumentEmployeeDocument", "onCloseDocument"])
  ], 64))
}